var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeople = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17A9.642 9.642 0 019 15.75 9.642 9.642 0 0113.66 17zM9 12a3.5 3.5 0 10-3.5-3.5A3.5 3.5 0 009 12zm0-5a1.5 1.5 0 11-1.5 1.5A1.5 1.5 0 019 7zm7.04 6.81A4.193 4.193 0 0118 17.25V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12a3.5 3.5 0 000-7 3.446 3.446 0 00-1.5.35 5.461 5.461 0 010 6.3A3.446 3.446 0 0015 12z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeople);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/people.bfcd429efd497f11e99044ede6701a36.svg";